import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import TransactionsList from "./pages/TransactionsList";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/transactions" element={<TransactionsList />} />
      </Routes>
    </Router>
  );
}

export default App;
